
export const VERSION = '5.4.22'; // Update this manually on each release

